import { useState, useEffect } from 'react'

export function convertToReadableDate(dateString) {
  const date = new Date(dateString)
  return `${date.getMonth() + 1}/${date.getDate()}/${Number(
    String(date.getFullYear()).substring(2, 4)
  )}`
}

export function cookieStringToObject() {
  return document.cookie.split(/; */).reduce((obj, str) => {
    if (str === '') return obj
    const eq = str.indexOf('=')
    const key = eq > 0 ? str.slice(0, eq) : str
    let val = eq > 0 ? str.slice(eq + 1) : null
    if (val != null)
      try {
        val = decodeURIComponent(val)
      } catch (ex) {
        /* pass */
      }
    obj[key] = val
    return obj
  }, {})
}

export function useInput(initialValue, onChange) {
  const [value, setValue] = useState(initialValue)

  return {
    value,
    setValue,
    reset: () => setValue(''),
    bind: {
      value,
      onChange: event => {
        const newValue = typeof event !== 'object' ? event : event.target.value
        if (typeof onChange === 'function') onChange(newValue)
        setValue(newValue)
      }
    }
  }
}

export function runOnEnter(func) {
  return function runOnEnterHandler(e, ...props) {
    if (e.key === 'Enter') func(e, ...props)
  }
}

export function runOnKey(func, key) {
  return function runOnKeyHandler(e, ...props) {
    if (e.key === key) func(e, ...props)
  }
}

export function debounce(callback, wait) {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => callback(...args), wait)
  }
}

export function useDebounce(func, delay) {
  const [debouncedFunction, setDebouncedFunction] = useState()

  useEffect(() => {
    setDebouncedFunction(() => debounce(func, delay))
  }, [func, delay])

  return debouncedFunction
}

export function constantToReadable(text) {
  return text
    .split('_')
    .filter(a => a)
    .map(word => word[0].toUpperCase() + word.slice(1, word.length).toLowerCase())
    .join(' ')
}

export function camelToReadable(text) {
  return (text.match(/[A-Za-z][a-z]*/g) || []).join(' ').toLowerCase()
}

export function copyToClipboard(str) {
  const el = document.createElement('textarea')
  el.value = str
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
